export const userData = {
  user: {
    active: "1",
    android_version: "11",
    app_version: "1.0",
    bank_account_num: "",
    bank_ifsc: "",
    coins: "520",
    coins_in: "520",
    coins_leader: "0",
    coins_out: "0",
    coins_ref: "0",
    country_code: "IN",
    device_brand: "Redmi",
    device_id: "57d6378b4b60d142",
    device_model: "Redmi Note 8 Pro",
    device_pub_key:
      "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAuj+MlVSQyAKjc879UdCnIQS3paR2XMzODS53LPReLSqhZVadN6uGO0CV7dEvIDeo6m1fPNs2Q29vawAhGA+iM7nG0C7mceUdhFASHDnIEOCTy2nZZLYwyQyezCmFNH0FvgwZ0GoAoHrf9WuiHaf36hRQifaq5V12d29i6Bv6cNrBsXOP7NLGg0iUUsr3X5d2iZtliG6FdpuiPHgtWcLEBM9+f8neWah5Kha9wXRNEpkPrfCKskOB21KQWgZo4NiMEeMK0LtkFLB5dAonF5EGaBRy5Obe0O4hC0EveWoZ0jjy+SwoKOm1JUdvTCBiPhudijbD9lwt6XYhtIToB0MUeQIDAQAB",
    device_utm_source: "google-play",
    doj: "24 November 2025, 06:21 AM",
    email: "sanchitmishra38483@gmail.com",
    fcm_token:
      "cLZEfWebR9Kcf_lUi9aVUs:APA91bEiZDsDXUrRvuBa_hj8lV7VeQlXndxGemouUrQohzy_lcYRmslOPzhADhnZ49q9QHDytQX0loRsT60mLSVHLQe8fwX7sp0FlJ9E4u0Jb5KKaQ0294Y",
    freefire_id: "",
    gaid: "12cc7418-c687-413f-a192-3a3e43ad32d2",
    image:
      "https://lh3.googleusercontent.com/a/ACg8ocIW-cVni7FM741Inu96WwFZ0qvVu1MbFf3DzQOWz4rtBkSRTw=s96-c",
    invites: "0",
    invites_current_buffer: "0",
    invites_cutting: "0",
    invites_visible: "0",
    ip: "2405:204:1029:97d8::118f:28a4",
    isp: "unknown",
    kochava: "0",
    last_activity: "24 November 2025, 07:22 AM",
    name: "Moon",
    offers: "0",
    paypal: "",
    phone: "6397664268",
    pincode: "201307",
    redeem_enabled: "1",
    refer_code: "c9811a9a",
    referrer: "",
    session: "1",
    state: "Uttarpradesh",
    telegram_id: "",
    total_offers: "0",
    upi: "6397664268@pthdfc",
    utm_raw: "utm_source=google-play&utm_medium=organic",
    uuid: "Fg92aCcZq6Z5LwIMJDzk5BfcbJv2",
  },
};
